import { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { useTiktokCampaignDetails } from 'src/Redux/campaignTiktokDetailsApi/useTiktokCampaignDetails'
import {
  campaignDetailsViewedEvent,
  locationEvent,
  pageViewEvent,
} from 'src/Helpers/TagManager'
import { pageInfo } from 'src/Helpers/TagManager/pageInfo'
import { getUserId } from 'src/Redux/auth-process/userSlice/selectors'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { getAmountOfCampaigns } from 'src/Redux/campaignList-process'

export const useTikTokCampaignDetailsPage = (): void => {
  const userId = useSelector(getUserId)

  const { campaignDetails } = useTiktokCampaignDetails()
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)

  const validStatuses = [
    'running',
    'ended',
    'stopped',
    'canceled_by_admin',
    'stopped_by_admin',
    'in_process',
  ] as const

  const isStatusForViewEvent = validStatuses.includes(
    campaignDetails?.status as (typeof validStatuses)[number],
  )

  useEffect(() => {
    if (userId) {
      pageViewEvent({
        userID: userId,
        currentPageInfo: pageInfo.campaignDetails,
      })
      locationEvent()
    }
  }, [userId])

  useEffect(() => {
    if (isStatusForViewEvent && userId && campaignDetails) {
      campaignDetailsViewedEvent({
        userId,
        campaignId: campaignDetails?.id,
        platformName: CampaignPlatformTypeEnum.TIKTOK,
        campaignNumber: amountOfCampaigns,
        campaignType: campaignDetails?.type || CampaignTypeEnum.BASIC,
        amountPaid: Number(campaignDetails?.amount) || 1,
        campaignStartDate: campaignDetails?.startDate,
        campaignEndDate: campaignDetails?.endDate,
        campaignStatus: campaignDetails?.status,
      })
    }
  }, [isStatusForViewEvent, amountOfCampaigns, campaignDetails, userId])
}
